import React, { FunctionComponent } from 'react';
import './FiltersSelected.scss';
import { IFiltersSelectedProps } from './IFiltersSelectedProps';
import IRefiners from "../../../Models/IRefiners";
import { Chip, ChipButton } from '@udir-design/react/beta';
import IRefiner from '../../../Models/IRefiner';



export const FiltersSelected: FunctionComponent<IFiltersSelectedProps> = ({ isDesktop, filters, results, emptyFilters, onRemoveFilter }) => {
  if (!filters || filters === undefined) {
    return null;
  }

  const activeFilters = getActiveFilters(filters);

  if (activeFilters.length === 0) {
    return null;
  }

  const onRemoveAll = () => {
    if (emptyFilters) {
      emptyFilters();
    } else {
      handleRemoveAllFilters();
    }
  };

  const handleChipRemove = (filter: ActiveFilter) => {
    // Always use the callback to remove the filter from URL and re-run the query
    // Don't try to click checkboxes as state may be out of sync with URL
    if (onRemoveFilter) {
      onRemoveFilter(filter.filterName, filter.entry.RefinementValue);
    }
  };

  return (
    <div className={isDesktop ? "filterChoices" : "filterChoicesMobile"}>
      <div className="filterChipsGroup">
        {activeFilters.map((filter) => (
          <Chip.Removable
            data-color="support1"
            data-size={isDesktop ? 'md' : 'sm'}
            key={`${filter.filterName}-${filter.entry.RefinementToken}`}
            aria-label={`Fjern filter ${filter.entry.RefinementName}`}
            onClick={() => handleChipRemove(filter)}
          >
            {filter.entry.RefinementName}
          </Chip.Removable>
        ))}
        {activeFilters.length >= 2 && (
            <ChipButton data-color="neutral" data-size={isDesktop ? 'md' : 'sm'} aria-label="Fjern alle filtre" onClick={onRemoveAll} className="removeAllChip">
                Fjern alle
            </ChipButton>
        )}
      </div>
      
    </div>
  );
};

interface ActiveFilter {
  filterName: string;
  entry: IRefiner;
}

function getActiveFilters(localFilters: IRefiners[]): ActiveFilter[] {
  const activeFilters: ActiveFilter[] = [];
  
  localFilters.forEach(filter => {
    const checkedFilters = filter.Entries.filter(val => val.checked === true);
    checkedFilters.forEach(entry => {
      activeFilters.push({
        filterName: filter.Name,
        entry: entry
      });
    });
  });

  return activeFilters;
}

function handleRemoveAllFilters() {
  // Find all checked checkboxes
  const checkedCheckboxes = document.querySelectorAll<HTMLInputElement>(
    '.filterContainer input.ds-input[type="checkbox"]:checked'
  );
  
  // Only click non-indented checkboxes (parents and standalone filters)
  // Children will be handled automatically by parent's onCheckBoxmarked
  checkedCheckboxes.forEach(checkbox => {
    const container = checkbox.closest('.checkBox');
    const isChild = container && container.classList.contains('checkboxIndetation');
    
    if (!isChild) {
      checkbox.click();
    }
  });
}


export default FiltersSelected;